import * as yup from "yup"
import "yup-phone-lite"
import { Form, Input, Checkbox, Radio } from "components/Form"

export default function TopMomentsForm({ moments }) {
  const required = "This is required."
  const nameValidation = yup.string().required(required)

  const momentNames = moments.map((moment) => moment.value)

  const formConfig = {
    mode: "onChange",
    schema: yup.object().shape({
      Moments: yup.array().min(1, "Please pick at least one moment").max(5, "Choose up to 5 Moments"),
    }),
  }

  return (
    <div classname="relative">
      <div className="px-5 lg:px-16">
        <h2 className="text-tertiary pb-4">Pick Your Top 5</h2>
        <p className="text-gray-light pb-4">
          Countless stories have shaped the fabric of our government during the last 25 years. Vote for the five moments
          on our list of transformative moments that resonate most with you as we celebrate the experiences that define
          this era!
        </p>
        <p className="text-gray-light pb-4">
          <strong>My Top Moments</strong> (choose up to 5)
        </p>

        <Form name="top-moments" isLinkedIn={true} config={formConfig} gtmPrefix="voting_modal">
          <Checkbox name="Moments" label="" options={momentNames} />
          <div className="flex justify-end mt-5">
            <button type="submit" className="primary-link self-end md:mr-8 z-[10000]">
              Submit
            </button>
          </div>
        </Form>
      </div>
    </div>
  )
}
